/**
 * Ensures slugs containing apostrophes, etc. do not interfere with construction of Sanity queries
 *
 * @example
 * sanitizeSlug("/bell's palsy") // '"/bell's palsy"'
 * */
const sanitizeSlug = (slug: string) => JSON.stringify(slug);

export default sanitizeSlug;
